module.exports = __webpack_public_path__ + "static/media/29DUNON2.c433c917.jpg";